import React from 'react';
import PropTypes from 'prop-types';
import styles from './NightNumber.module.scss';

const NightNumber = ({nightKey, children, clickHandler, selected, disabled}) => {

    const containerClasses = [styles.container];
    if (selected) containerClasses.push(styles.selected);
    if (disabled) containerClasses.push(styles.disabled);

    return (
        <div key={nightKey} className={containerClasses.join(' ')} onClick={!disabled ? clickHandler : null}>
            {children}
        </div>
    );
};

NightNumber.propTypes = {
    nightKey: PropTypes.string,
    children: PropTypes.any,
    clickHandler: PropTypes.func,
    selected: PropTypes.bool,
    disabled: PropTypes.bool,
};

NightNumber.defaultProps = {
    nightKey: null,
    children: null,
    clickHandler: () => null,
    selected: false,
    disabled: false,
};

export default NightNumber;